import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const InfoCard: React.FC = () => {
  const { t } = useLanguage();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = (): void => {
    setDismissed(true);
  };

  return (
    <div className="bg-teal-50 border border-teal-200 rounded-lg p-4 mb-4 flex items-start justify-between gap-4">
      <div>
        <p className="font-semibold text-teal-900 mb-1">{t('infocard_title')}</p>
        <p className="text-sm text-teal-800">{t('infocard_body')}</p>
      </div>
      <button
        onClick={handleDismiss}
        className="text-teal-600 hover:text-teal-900 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded shrink-0 text-sm font-medium"
      >
        {t('infocard_dismiss')}
      </button>
    </div>
  );
};
